import React, { Component } from "react";
import { withRouter } from 'react-router-dom'

class Interstitial extends Component {
  static ZONE_IDS = {
    mobile: "5182282",
    desktop: "5182282"
  };

  static FREQUENCY = 5;

  render() {
    const { userAgent } = this.props;
    const device = userAgent.toLowerCase().indexOf('mobile') > -1
      ? 'mobile'
      : 'desktop'

    if (!device) {
      return null
    }

    const triggerParams = {
      type: "application/javascript",
      src: "https://a.pemsrv.com/fp-interstitial.js",
      "data-selector": "iselector",
      "data-ad_frequency_count": "1",
      "data-ad_frequency_period": Interstitial.FREQUENCY,
      "data-browser_settings": "1",
      "data-ad_trigger_method": "2",
      "data-idzone": Interstitial.ZONE_IDS[device],
      "data-type": device,
      "data-ad_trigger_class":
        device === "desktop" ? "is-trigger" : "ism-trigger"
    };

    return (
      <script {...triggerParams} />
    );
  }
}

export default withRouter(Interstitial);
